import { DateTime } from "luxon";

const formatDate = (date: string) => {
  return DateTime.fromISO(date).toFormat("dd/MM/yyyy");
};

export const dateUtils = {
  formatDate,
};
